import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { bindPropStore } from "../bindProps";
import { emit, objects, text } from "../helpers";

var root = $.from_html(`<div class="slex-toc-label"> </div>`);
var root_1 = $.from_html(`<a> </a>`);
var root_2 = $.from_html(`<nav class="slex-toc"><!> <div class="slex-toc-list"></div></nav>`);

export default function Toc($$anchor, $$props) {
	$.push($$props, true);

	let p = $.state($.proxy({}));

	$.user_effect(() => bindPropStore($$props.props, (next) => $.set(p, next, true)));

	var nav = root_2();
	var node = $.child(nav);

	{
		var consequent = ($$anchor) => {
			var div = root();
			var text_1 = $.child(div, true);

			$.reset(div);
			$.template_effect(($0) => $.set_text(text_1, $0), [() => text($.get(p).label)]);
			$.append($$anchor, div);
		};

		$.if(node, ($$render) => {
			if ($.get(p).label) $$render(consequent);
		});
	}

	var div_1 = $.sibling(node, 2);

	$.each(div_1, 21, () => objects($.get(p).items), $.index, ($$anchor, item) => {
		const href = $.derived(() => text($.get(item).href ?? $.get(item).id));
		const normalizedHref = $.derived(() => $.get(href).startsWith("#") || $.get(href).startsWith("/") ? $.get(href) : `#${$.get(href)}`);
		const isActive = $.derived(() => $.get(p).active === $.get(normalizedHref) || $.get(p).active === $.get(normalizedHref).replace(/^#/, ""));
		var a = root_1();
		let classes;
		var text_2 = $.child(a, true);

		$.reset(a);

		$.template_effect(
			($0) => {
				classes = $.set_class(a, 1, 'slex-toc-link', null, classes, { 'slex-toc-link--active': $.get(isActive) });
				$.set_attribute(a, 'href', $.get(normalizedHref));
				$.set_attribute(a, 'aria-current', $.get(isActive) ? "true" : undefined);
				$.set_text(text_2, $0);
			},
			[
				() => text($.get(item).label ?? $.get(item).title ?? $.get(normalizedHref).replace(/^#/, ""))
			]
		);

		$.delegated('click', a, (event) => emit($$props.ctx, "click", {
			type: "click",
			target: $$props.ctx.id,
			href: $.get(normalizedHref),
			native: event
		}));

		$.append($$anchor, a);
	});

	$.reset(div_1);
	$.reset(nav);

	$.template_effect(
		($0) => {
			$.set_attribute(nav, 'data-orientation', $.get(p).orientation === "horizontal" ? "horizontal" : "vertical");
			$.set_attribute(nav, 'aria-label', $0);
		},
		[() => text($.get(p).label, "Contents")]
	);

	$.append($$anchor, nav);
	$.pop();
}

$.delegate(['click']);